export default __webpack_public_path__ + "static/media/icon-widget-empty.05eeef02.svg";